export const FIND_PSEUDONYM_SUCCESS = 'FIND_PSEUDONYM_SUCCESS';

export const findPseudonymSuccess = pseudonym => ({
    type: FIND_PSEUDONYM_SUCCESS,
    payload: { pseudonym },
});
